import React, { useEffect, useRef, useState } from 'react';
import Breadcrumbs from '../../components/BreadCrumbs';
import Pagination from '../../components/tables/pagination/Pagination';
import CustomLoading from '../../components/customLoading/CustomLoading';
import Table from '../../components/tables/Table';
import loaderImage from "../../assets/icons/part-logo.png";
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import Card from '../../components/cards/Card';
import { FaEye } from 'react-icons/fa';
import { FaDownload } from 'react-icons/fa6';
import Button from '../../components/buttons/Button';
import { Link } from 'react-router-dom';
import Dropdown from '../../components/inputFields/DropDown';
import { getInvoices, patchInvoices } from '../../services/clinic/invoice';
import { toast } from 'react-toastify';
import ViewPdfModalFromComponent from '../../components/PdfViewer/ViewPdfModalFromComponent';
import { getUserName } from '../../utils/localStoarege';
import { getConsultationInvoices, getConsultationStats } from '../../services/clinic/consultation';
import { IoMdRefresh } from 'react-icons/io';
import SearchBar from '../../components/searchBar/SearchBar';


function ConsultationInvoice() {
    const [cardData, setCardData] = useState([
        {
            title: "Total Invoice Generated",
            count: "--",
        },
        {
            title: "Total Amount Received",
            count: "--",
        },
        {
            title: "Online Paid",
            count: "--",
        },
        {
            title: "Cash Paid",
            count: "--",
        },
    ]);

    const [tableData, setTableData] = useState({});

    const headers = [
        { label: "ID", key: "id" },
        { label: "Name", key: "name" },
        { label: "Amount", key: "amount" },
        { label: "Payment Mode", key: "mode" },
        { label: "Phone", key: "phone" },
        { label: "Date", key: "created_at" },
        { label: "Action", key: "action" },
        { label: "Transaction Number", key: "transaction_number" },
    ];

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [pdfToDisplay, setPdfToDisplay] = useState({});
    const [searchText, setSearchText] = useState("");


    const pageSize = 100;

    const fetchData = async ({ centerName, query }) => {
        setLoading(true);
        try {
            let res = await getConsultationInvoices(centerName, query);
            if (res.status === 200) {
                setTableData(res.data);
            } else {
                toast.error("Unable to fetch consultation");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Consultation:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchStats = async (centerName) => {
        try {
            let res = await getConsultationStats(centerName);
            if (res.status === 200) {
                setCardData([
                    {
                        title: "Total Invoice Generated",
                        count: res.data.total_invoices_generated,
                    },
                    {
                        title: "Total Amount Received",
                        count: res.data.total_amount_received,
                    },
                    {
                        title: "Online Paid",
                        count: res.data.online_paid,
                    },
                    {
                        title: "Cash Paid",
                        count: res.data.cash_paid,
                    },
                ]);
            } else {
                toast.error("Unable to fetch stats");
            }
        } catch (error) {
            console.error("Error fetching Stats:", error);
        }
    };

    useEffect(() => {
        fetchData({ centerName: getUserName(), query: "" });
        fetchStats(getUserName());
    }, []);


    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const openPdfModal = (values) => {
        setPdfToDisplay(values);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
    };

    const handleApprovalChange = async (id, value) => {
        try {
            let res = await patchInvoices(id, value);
            if (res.status === 200) {
            } else {
                toast.error("Error Updating Status");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Machines:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (query) => {
        setSearchText(query);
        fetchData({ centerName: getUserName(), query: "&search=" + query });
    };

    const resetSearch = () => {
        setSearchText("");
        fetchData({ centerName: getUserName(), query: "" });
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home' },
            { name: 'Consultation' },
        ]} />
        <div className="py-3">
            <StyledHeadingText text={"Invoice"} />
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-2">
                {cardData.map((card, index) => (
                    <Card title={card.title} count={card.count} />
                ))}
            </div>
        </div>
        <div className="flex flex-row justify-between py-4 items-center">
            <StyledHeadingText text={"History"} />
            <Link to='/consultation-invoice/add'>
                <Button children={"Add Invoice"} className="bg-primary text-white rounded-lg" />
            </Link>
        </div>
        <div className="flex flex-row items-center gap-3">
            <div className="md:w-[30%] lg:w-[20%] self-end mb-2">
                <SearchBar placeholder="Search Patients..." value={searchText} onSearch={handleSearch} />
            </div>
            {
                searchText !== "" ?
                    <IoMdRefresh size={23} className='text-primary cursor-pointer' onClick={resetSearch} /> : <></>
            }
        </div>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading imageSrc={loaderImage} size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={tableData?.results?.map((item, index) => (
                            {
                                id: <p>{item.s_no}</p>,
                                name: <p>{item.name}</p>,
                                amount: <p>{item.amount}</p>,
                                mode: <p>{item.mode}</p>,
                                phone: <p>{item.mobile_number}</p>,
                                created_at: <p>{item.created_at}</p>,
                                transaction_number: <p>{item.transaction_number}</p>,
                                action: <span className='cursor-pointer self-center items-center justify-center' onClick={() => openPdfModal(item)} ><FaEye color='green' size={20} /></span>,
                            }
                        )
                        )}
                    />
                </div>}
        {/* Table End */}
        {/* Pagination Begin */}
        {
            tableData.count !== 0 ?
                <div className="xl:pl-5 pl-0">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={Math.ceil(tableData?.count / pageSize)}
                        pageSize={pageSize}
                        totalEntries={tableData?.count}
                        onPageChange={handlePageChange}
                        data={tableData}
                        setTableData={setTableData}
                    />
                </div> : <></>
        }
        <ViewPdfModalFromComponent isConsultancy={true} contentLabel={"PDF"} isOpen={modalIsOpen} onRequestClose={closeModal} values={pdfToDisplay} />
    </>);
}

export default ConsultationInvoice;